import CountryDialCode from "../../uiComponents/CountryDialCode";
import React from "react";
import {getTranslate} from "../../localization/localizeSlice";
import {useSelector} from "react-redux";

export default ({id, inputRef, placeholder, selectedDialCode, selectDialCode, countryCode, autoFocus, style={}}) => {
    const state = useSelector(state => state);
    const translate = getTranslate(state);
    return <div className={"shadowBoxInput"} style={style}>
        <div style={{float: "left", width: "10.71rem"}} onClick={e => e.preventDefault()}>
            <CountryDialCode
                defaultCountryCode={countryCode}
                selectedDialCode={selectedDialCode}
                setSelectedDialCode={selectDialCode}
            />
        </div>
        <input
            ref={inputRef}
            type={"text"}
            name={id}
            autoComplete={"off"}
            placeholder={translate(placeholder)}
            style={{
                width: "calc(100% - 10.71rem)",
                borderLeft: "none",
                boxSizing: "border-box"
            }}
            data-keyboard-layout={"numbers"}
            autoFocus={autoFocus}
        />
    </div>
}